import * as React from 'react';
import { Box, TextField, Typography, Alert, IconButton, Modal, Snackbar, Table, TableBody, TableCell, TableHead, TableRow, Card, CardContent, Tooltip, Grid, Paper, TableContainer, Chip } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { GridRowId } from '@mui/x-data-grid';
import { Refresh, Close, SimCardDownload, FileUpload, Download } from '@mui/icons-material';
import { bucketName, handleDownload, getStatusColor, baseUrl1, newstatusValueArray, Dispatchstatus } from '../Pages/ApiCommonService';
import { fetchJob, viewUploadedFileForDownload, generateURLForDownloadInputFiles, viewUploadedFileRemarks } from '../ApiSevices/JobListingApis';
import { GridTable } from '../Sidebar/SidebarStyles';
import { expTokenProcessAndGenerate } from '../ApiSevices/AuthApis';
import FileReUploadModal from './FileReUploadpage';
type Order = 'asc' | 'desc';
interface JobFileInfo {
    id: number;
    FileName: string;
    FileType: string;
    FileForId: any;
    Status: string;
    ToFileName: string;
    FileSize: string;
    IsCorrupted: boolean;
    IsConverted: boolean;
    IsScanned: boolean;
    IsMerged: boolean;
    IsPublished: boolean;
    JobId: string;
    CreatedOn: string;
    PublishedFilePath: any
}
interface TableProps {
    displaysidebar: boolean;
}
interface Row {
    DispatchedOn: string;
    MatchScore: string;
    JobTypeId: any;
    LobCode: string;
    CreatedOn: any;
    UpdatedOn: any;
    Id: string;
    ClientName: string;
    JobId: string;
    JobOwner: string;
    MacroFile: string;
    Status: string;
    IsActive: boolean;
    document?: File | null;
    documentName?: string;
}

interface State {
    rows: Row[];
    order: Order;
    page: number;
    UFJobid: any;
    rowsPerPage: number;
    selectedRow: Row | null;
    selectedRowIds: GridRowId[];
    snackbarOpen: boolean;
    snackbarMessage: any;
    snackbarSeverity: any;
    loading: boolean;
    fileInfo: JobFileInfo[];
    fileReUploadInfo: JobFileInfo[];
    Remarksinfo: any;
    getJobId: any;
    isActivityDrawerOpen: boolean;
    isFileModelOpen: boolean;
    isFileReuploadModal: boolean;
    Type_JobTypeId: any;
    ReuploadRowId: any;
    isErrorCardOpen: boolean;
    searchTerm: string;
    searchQuery: string;
    isDialogOpen: boolean;
    selectedJobId: null;
    selectedJobIdforModel: null;
    selectedInstanceId: null;
    selectedFiles: File | null;
    statusFilterAnchorEl: null;
    selectedStatusFilter: '';
    totalCount: any;
    statusId: any;
    brokerId: number;
}


class fileReUpload extends React.Component<TableProps, State> {
    docTypeArray: Record<number, string> = { 1: "CT", 2: "PT", 3: "CTE", 4: "PTE", 5: "Acord Application", 6: "Carrier Quote", 7: "Proposal", 8: "Schedule", 9: "Binder" }
    queryParams = new URLSearchParams(window.location.search);

    constructor(props: TableProps) {
        super(props);
        this.state = {
            rows: [],
            UFJobid: '',
            order: 'desc',
            selectedRow: null,
            selectedRowIds: [],
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
            loading: false,
            fileInfo: [],
            fileReUploadInfo: [],
            Remarksinfo: null,
            getJobId: null,
            isActivityDrawerOpen: false,
            isFileModelOpen: false,
            isFileReuploadModal: false,
            Type_JobTypeId: null,
            ReuploadRowId: null,
            isErrorCardOpen: false,
            searchTerm: '',
            searchQuery: '',
            isDialogOpen: false,
            selectedJobId: null,
            selectedJobIdforModel: null,
            selectedInstanceId: null,
            selectedFiles: null,
            statusFilterAnchorEl: null,
            selectedStatusFilter: '',
            totalCount: '',
            brokerId: 0,
            page: 0,
            rowsPerPage: 10,
            statusId: this.queryParams.get('statusId') || '0',
        };
    }

    statusValueArray: Record<number, string> = {
        1: "Pending",
        2: "InProgress",
        3: "Completed",
        4: "Failed",
    }

    showSnackbar = (message: string, severity: "success" | "error" | "info" | "warning") => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    componentDidMount(): void {
        this.fetchJobs();
    }

    componentDidUpdate(prevProps: Readonly<TableProps>, prevState: Readonly<State>, snapshot?: any): void {
        const queryParams = new URLSearchParams(window.location.search);
        if (prevState?.statusId != (queryParams.get('statusId') || '0')) {
            this.setState({ statusId: queryParams.get('statusId') || '0' });
            this.fetchJobs();
        }
    }

    fetchJobs = async () => {
        this.setState({ loading: true });
        const { page, statusId, brokerId } = this.state;

        try {
            const jobResponse = await fetchJob(page, 0, brokerId, Number(statusId), "");
            if (jobResponse && jobResponse?.data?.length > 0) {
                this.setState({ rows: jobResponse?.data, totalCount: jobResponse?.totalCount });

            }
        } catch (error) {
            console.error('Error fetching jobs:', error);
            this.showSnackbar('Failed to fetch jobs.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleSearchChange = (event: any) => {
        const term = event.target?.value?.trim();
        this.setState({ searchTerm: term });
    };

    handleSearchClick = async () => {
        this.setState({ loading: true, searchQuery: this.state.searchTerm });
        try {
            const searchResponse = await fetchJob(this.state.page, this.state.rowsPerPage, this.state.brokerId, Number(this.state.statusId), this.state.searchTerm);
            if (searchResponse && searchResponse?.data?.length > 0) {
                searchResponse?.data?.map((obj: any) => {
                    if (![24, 26, 27]?.includes(obj?.Status)) {
                        obj.Status = 24;
                    }
                    return { ...obj };
                });
                this.setState({ rows: searchResponse?.data, totalCount: searchResponse?.totalCount, UFJobid: searchResponse?.data[0]?.Id });
            }
            else if (searchResponse?.data?.length == 0) {
                this.setState({ totalCount: searchResponse?.totalCount });
            }
        } catch (error) {
            console.error('Error in searching jobs:', error);
            this.showSnackbar('Failed to searching jobs.', 'error');
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFileInfoClick = (id: string) => async () => {
        // this.setState({ loading: true });
        try {
            const fileRemarksResponse = await viewUploadedFileRemarks(id);
            const fileInfoResponse = await viewUploadedFileForDownload(id);
            if (fileInfoResponse && fileInfoResponse?.length > 0 || fileRemarksResponse && fileRemarksResponse?.length > 0) {
                const updatedFileInfo = fileInfoResponse?.map((fileObj: any, index: any) => ({
                    ...fileObj,
                    rowId: index + 1
                }));

                this.setState({
                    getJobId: fileRemarksResponse.JobId || "",
                    Remarksinfo: fileRemarksResponse.Remarks || "",
                    fileInfo: updatedFileInfo || [],
                    isFileModelOpen: true
                });

            }
        } catch (error) {
            this.showSnackbar("Failed to fetch fileInfo", 'error');
            console.error('Error fetching fileInfo:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    handleFileReupload = (id: string, jobTypeId: string) => async () => {
        // this.setState({ loading: true });
        try {
            const fileReUploadResponse = await viewUploadedFileForDownload(id);
            let updatedReuploadFileInfo = [];
            if (fileReUploadResponse && fileReUploadResponse.length > 0) {
                updatedReuploadFileInfo = fileReUploadResponse.map((fileObj: any, index: number) => ({
                    ...fileObj,
                    rowId: index + 1
                }));
            }
            this.setState({
                fileReUploadInfo: updatedReuploadFileInfo,
                isFileReuploadModal: true,
                Type_JobTypeId: jobTypeId
            });
        } catch (error) {
            this.showSnackbar("Failed to fetch fileReUploadInfo", 'error');
            console.error('Error fetching fileReUploadInfo:', error);
        } finally {
            this.setState({ loading: false });
        }
    };

    renderFileInfoDrawer = () => {
        const { fileInfo, isFileModelOpen, Remarksinfo, getJobId } = this.state;
        const downloadFile = async (bucketName: string, fileName: string, name: string) => {
            const fileInfoPath = fileName?.split('.com/');
            try {
                const blobUrlForFile = await generateURLForDownloadInputFiles(bucketName, fileInfoPath);
                if (blobUrlForFile) {
                    handleDownload(blobUrlForFile, name);
                    this.showSnackbar(`The selected file ${name} downloaded successfully!`, 'success');
                }
            } catch (error) {
                this.showSnackbar("There is an error in downloading the file", 'error');
                console.error('Error in downloading:', error);
            }
        };

        const discrepancy_downloadFile = async (getJobId: string) => {
            try {
                const token = sessionStorage.getItem('token');
                const url = `${baseUrl1}api/Policy/export-policy-data/${getJobId}`;
                const Token = await expTokenProcessAndGenerate(token);
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${Token}`
                    }
                });
                if (response.ok) {
                    const blob = await response.blob();
                    const fileName = `${getJobId}_discrepancy.xlsx`;
                    const blobUrl = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(blobUrl);
                    this.showSnackbar(`The selected ${getJobId}_discrepancy.xlsx downloaded successfully!`, 'success');
                } else {
                    throw new Error('Failed to download file: ' + response.statusText);
                }
            } catch (error) {
                console.error('Error in downloading:', error);
                this.showSnackbar("There is an error in downloading the file", 'error');
            }
        };

        return (
            <Modal
                open={isFileModelOpen}
                onClose={() => this.setState({ isFileModelOpen: false })}
                aria-labelledby="file-info-modal"
                aria-describedby="file-information-details"
            >

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    marginTop: '40px',
                    padding: '16px',
                    height: '100vh',
                    overflow: 'auto',
                }}>
                    <Card sx={{
                        width: '90%',
                        maxWidth: '1000px',
                        maxHeight: '90vh',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        borderRadius: '12px',
                        padding: '15px',
                        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                        backgroundColor: '#fff',
                    }}>
                        <Grid container spacing={1}>
                            <Grid item lg={11.5} sm={12} marginTop={0.5}>
                                <Typography variant="h6" gutterBottom>
                                    <span style={{ color: '#ab9e9ed6' }}> View</span>
                                </Typography>
                            </Grid>

                            <Grid item lg={0.5} sm={12} marginTop={-1}>
                                <IconButton onClick={() => this.setState({ isFileModelOpen: false })} className="close-button">
                                    <Close />
                                </IconButton>
                            </Grid>
                        </Grid>

                        <CardContent className="card-section">
                            <Typography variant="h6" gutterBottom>Input Files</Typography>
                            <TableContainer component={Paper} elevation={3}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {["Sl No", "File Name", "Doc_fieldType", "File Size", "File Type", "Action"].map((head) => (
                                                <TableCell key={head}>{head}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {fileInfo.map((file, index) => (
                                            <TableRow key={file?.id || index}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell >{file?.FileName}</TableCell>
                                                <TableCell>{this.docTypeArray[file?.FileForId]}</TableCell>
                                                <TableCell>
                                                    {file?.FileSize ? `${(Number(file?.FileSize) / (1024 * 1024)).toFixed(2)} MB` : "N/A"}
                                                </TableCell>
                                                <TableCell>{`.${file?.FileType}`}</TableCell>
                                                <TableCell>
                                                    <Tooltip title="Download File">
                                                        <IconButton color="primary" size="small" onClick={() => downloadFile(bucketName, file?.PublishedFilePath, file?.FileName)}>
                                                            <Download fontSize="small" />
                                                        </IconButton>
                                                    </Tooltip>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>

                        <CardContent className="card-section1">
                            <Typography variant="h6" gutterBottom>Output Files</Typography>
                            <TableContainer component={Paper} elevation={3}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            {["File Name", "Action"].map((head) => (
                                                <TableCell key={head}>{head}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>{getJobId}_discrepancy.xlsx</TableCell>
                                            <TableCell>
                                                <Tooltip title="Click to download the file">
                                                    <IconButton
                                                        color="primary"
                                                        className="output-file-download-btn"
                                                        onClick={() => discrepancy_downloadFile(getJobId)}
                                                    >
                                                        <Download />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </CardContent>

                        <CardContent className="card-section">
                            <Typography variant="h6">Remarks</Typography>
                            <Typography className="remarks-text">
                                {Remarksinfo?.length > 0 ? Remarksinfo : ''}
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>

        );
    };

    render() {
        const { rows, loading, snackbarOpen, snackbarMessage, snackbarSeverity, UFJobid, searchQuery } = this.state;
        const { displaysidebar } = this.props;

        const sortedRows = this.state?.searchQuery
            ? rows?.filter((row: any) =>
                row?.JobId?.toLowerCase()?.includes(this.state?.searchQuery.toLowerCase())
            )
            : [];

        const visibleRows = sortedRows;
        const dispatchDisabledStatuses = Object.keys(Dispatchstatus).map(Number);

        return (
            <>
                {loading && (
                    <Box sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        zIndex: 9999
                    }}>
                        <div className="loader"></div>
                    </Box>
                )}
                <GridTable sx={{ height: '100vh' }} displaysidebar={displaysidebar}>
                    <Grid container direction="column" spacing={0} sx={{ height: '100%' }}>
                        <Grid item sx={{ height: '7vh' }}>
                            <Grid container spacing={0}>
                                <Grid item lg={11.5} sm={11}>
                                    <TextField
                                        size="small"
                                        placeholder="Search by Job ID"
                                        value={this.state.searchTerm}
                                        onChange={this.handleSearchChange}
                                        sx={{
                                            '& .MuiInputBase-input::placeholder': {
                                                fontSize: '11px',
                                            },
                                            '& .MuiInputBase-input': {
                                                fontSize: '11px',
                                            },
                                            width: 200,
                                        }}
                                    />
                                    <Tooltip title="Click here for search result">
                                        <IconButton onClick={() => {
                                            this.handleSearchClick();
                                            this.setState({ isFileReuploadModal: false });
                                        }}
                                            sx={{ mb: 1.5, height: '33px', border: '0.2px solid #d0bcbca1', borderRadius: '9%' }}>
                                            <SearchIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                                <Grid item lg={.5} sm={1} marginTop={0.5}>
                                    <Tooltip title={"Click here to refresh the table"}>
                                        <span>
                                            <Refresh
                                                sx={{ cursor: "pointer", color: "blue", boxShadow: 'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px', border: '0.1px solid black' }}
                                                onClick={() => {
                                                    this.fetchJobs();
                                                    this.setState({
                                                        isFileReuploadModal: false,
                                                        searchQuery: '',
                                                        searchTerm: ''
                                                    });
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item sx={{ height: '23vh' }}>
                            <Paper sx={{ width: '100%', mb: 1, overflow: 'hidden', border: '0.5px solid #edebeb' }}>
                                <Table stickyHeader >
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontSize: '11px', width: 10 }}>S.No</TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 170 }}>JobId </TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 130 }}>JobTypeId </TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 130 }}>ClientName </TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "center" }}>CheckListType </TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 250, textAlign: "center" }}>Status </TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 130 }} >Actions</TableCell>
                                            <TableCell sx={{ fontSize: '11px', width: 130 }} >FileReUpload</TableCell>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                                <Box sx={{ maxHeight: 350, overflowY: 'auto', overflowX: 'auto' }}>
                                    <Table size="small">
                                        <TableBody>
                                            {visibleRows?.length === 0 ? (
                                                <TableRow>
                                                    <TableCell align="center"
                                                        sx={{
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            color: 'gray',
                                                            padding: '20px',
                                                            borderBottom: 'none',
                                                        }}>  No records to display
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                visibleRows?.map((row, index) => {
                                                    const statusKey: any = row.Status;
                                                    const { bg, text } = getStatusColor(Number(statusKey));
                                                    const isDispatchDisabled = dispatchDisabledStatuses.includes(statusKey);
                                                    return (
                                                        <TableRow hover key={row.Id}>
                                                            <TableCell sx={{ fontSize: '11px', width: 20 }}>
                                                                {index + 1}
                                                            </TableCell>

                                                            <TableCell sx={{ fontSize: '11px', width: 170, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                {row.JobId}
                                                            </TableCell>

                                                            <TableCell sx={{ fontSize: '11px', width: 130 }}>
                                                                {(() => {
                                                                    const jobTypeMapping: Record<number, string> = {
                                                                        1: "AR",
                                                                        2: "MR",
                                                                    };
                                                                    return jobTypeMapping[row.JobTypeId] || "Unknown";
                                                                })()}
                                                            </TableCell>

                                                            <TableCell sx={{ fontSize: '11px', width: 130 }}>
                                                                {row.ClientName}
                                                            </TableCell>

                                                            <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "center" }}>
                                                                {row.MacroFile}
                                                            </TableCell>

                                                            <TableCell sx={{ fontSize: '11px', width: 250, textAlign: "center" }}>
                                                                <Chip
                                                                    label={newstatusValueArray[statusKey]}
                                                                    size="small"
                                                                    sx={{
                                                                        backgroundColor: bg,
                                                                        color: text,
                                                                        fontWeight: 500,
                                                                        fontSize: '11px',
                                                                        height: '22px',
                                                                        borderRadius: '20px',
                                                                        px: 1,
                                                                    }}
                                                                />
                                                            </TableCell>

                                                            <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "start" }}>
                                                                <IconButton onClick={this.handleFileInfoClick(row.Id)} size="small">
                                                                    <SimCardDownload fontSize="small" />
                                                                </IconButton>
                                                            </TableCell>

                                                            <TableCell sx={{ fontSize: '11px', width: 130, textAlign: "center" }}>
                                                                {isDispatchDisabled ? (
                                                                    <Tooltip title="Icon is disabled">
                                                                        <span>
                                                                            <IconButton
                                                                                onClick={this.handleFileReupload(row.Id, row.JobTypeId)}
                                                                                size="small"
                                                                                disabled
                                                                            >
                                                                                <FileUpload fontSize="small" />
                                                                            </IconButton>
                                                                        </span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    <IconButton
                                                                        onClick={this.handleFileReupload(row.Id, row.JobTypeId)}
                                                                        size="small"
                                                                    >
                                                                        <FileUpload fontSize="small" />
                                                                    </IconButton>
                                                                )}
                                                            </TableCell>

                                                        </TableRow>
                                                    );
                                                })
                                            )}
                                        </TableBody>
                                    </Table>
                                </Box>
                            </Paper>
                        </Grid>
                        <Grid item sx={{ height: '70vh' }}>
                            {this.state.isFileReuploadModal && (
                                <FileReUploadModal
                                    modelJobTypeId={this.state.Type_JobTypeId}
                                    ReuploadRowId={this.state.ReuploadRowId}
                                    fileReUploadInfo={this.state.fileReUploadInfo}
                                    UfjobId={UFJobid}
                                    searchJob_ID={searchQuery}
                                    onSuccessfulUpload={(jobId) => this.handleFileReupload(jobId, this.state.Type_JobTypeId)()}
                                />
                            )}
                        </Grid>
                    </Grid>
                    {this.renderFileInfoDrawer()}

                </GridTable >

                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={2500}
                    onClose={() => this.setState({ snackbarOpen: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert onClose={() => this.setState({ snackbarOpen: false })} severity={snackbarSeverity} sx={{ width: "100%" }}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </>
        );
    }
}
export default fileReUpload;
